import React from 'react'

export default function Home() {
  return (
    <React.Fragment>
      <div className="siteLogoSection">
        <img src="images/logo.svg" alt="" />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
          exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
      </div>
      <div className="homeCardSection">
        <ul>
          <li>
            <img src="images/BID_FOR_INGREDIENTS.svg" alt="" />
            <p style={{ maxWidth: 108 }}>BUY/BID FOR INGREDIENTS</p>
          </li>
          <li>
            <img src="images/COMBINE_TO_MAKE_DISHES.svg" alt="" />
            <p style={{ maxWidth: 108 }}>COMBINE TO MAKE DISHES</p>
          </li>
          <li>
            <img src="images/STAKE_DISHES_TO_EARN_TOKENS.svg" alt="" />
            <p style={{ maxWidth: 130 }}>STAKE DISHES TO EARN TOKENS</p>
          </li>
          <li>
            <img src="images/TRADE_DISHES_ON_MARKETPLACES.svg" alt="" />
            <p style={{ maxWidth: 122 }}>TRADE DISHES ON MARKETPLACES</p>
          </li>
        </ul>
      </div>
      <div className="dishesSections">
        <div className="dishesHeadingSection">
          <h2>DISHES</h2>
        </div>
        <ul>
          <li>
            <div className="dishes_img"></div>
            <h3>FRENCH FRIES</h3>
          </li>
          <li>
            <div className="dishes_img"></div>
            <h3>RED THAI CURRY</h3>
          </li>
          <li>
            <div className="dishes_img"></div>
            <h3>CHEESE BURGER</h3>
          </li>
        </ul>
        <button>See more</button>
      </div>
      <div className="faqSection">
        <h2>FAQ</h2>
        <ul>
          <li>
            <p>Q. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
            <span>A. incididunt ut labore et dolore magna aliqua.</span>
          </li>
          <li>
            <p>Q. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
            <span>A. incididunt ut labore et dolore magna aliqua.</span>
          </li>
          <li>
            <p>Q. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
            <span>A. incididunt ut labore et dolore magna aliqua.</span>
          </li>
          <li>
            <p>Q. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
            <span>A. incididunt ut labore et dolore magna aliqua.</span>
          </li>
        </ul>
      </div>
    </React.Fragment>
  )
}
